<div class="animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="carga" [titulo]="'CARGA DE ARCHIVO'" [efecto]="true" [colapseName]="'carga'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #carga>
    <form [formGroup]="formulario" novalidate class="form-group">
      <div class="row">
        <div class="form-group col-md-4">
          <img *ngIf="true" [src]="csv" height="35" width="35" alt="">&nbsp;
          <label for="csvInput" class="letrasDanger">ArchivoCSV.csv*</label>
          <input type="file" class="form-control-file" id="csvInput" (change)="onFileSelect($event)" #fileInput
            accept=".csv" />
        </div>
      </div>
      <br>
      <br>
    </form>
  </ng-template>
  <div class="row">
    <div class="form-group col-md-12">
      <div *ngIf="formulario.invalid" class="alert alert-danger" role="alert">
        <b> Complete la información solicitada, luego se habilitara el botón...!!! </b>
      </div>
    </div>
  </div>
  <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
  <div class="row" *ngIf="!loading">
    <div class="form-group col-md-6">
      <button [routerLink]="['/emp/administrador/home-emp']" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
    <div class="form-group col-md-6">
      <button [disabled]="formulario.invalid" (click)="enviarFormulario()"
        class="btn btn-success btn-block btn-lg">Enviar</button>
    </div>
  </div>
</div>

<div class="animated fadeInRight" *ngIf="mostrarFormulario">

  <app-lfsa-card [innTemplate]="grid" [titulo]="'CARGAR DE ARCHIVO'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <div class="row">
      <div class="col-sm-12">
        <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
          (keyup)="onQuickFilterChanged()" #quickFilter />
      </div>
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="listaVacia">
      No existen datos para la lista.
    </div>
    <br>

    <ag-grid-angular class="{{empModulo.agGrid.class}}" #agGrid [ngStyle]="empModulo.agGrid.style"
      id="{{empModulo.agGrid.id}}" [paginationPageSize]=15 [pagination]="true" 
      [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
      [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </ng-template>
  <div class="row">
    <div class="form-group col-md-6">
      <button (click)="regresar()" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
    <div class="form-group col-md-6">
      <button [disabled]="!(rowData.length > 0)" (click)="guardar()"
        class="btn btn-outline-success btn-block btn-lg">Guardar</button>
    </div>
  </div>
  <br>
  <br>
</div>